import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueCookies from 'vue-cookies'
import VueSocketIO from 'vue-socket.io'
import router from './router'

Vue.config.productionTip = false

Vue.use(VueCookies);
Vue.$cookies.config('30d');

Vue.use(new VueSocketIO({
  debug: true,
  connection: 'https://fivechain.app',
  vuex: {
    store,
    actionPrefix: 'cgsock_',
    // mutationPrefix: 'SOCKET_'
  },
  // options: { path: "/app" } // Optional
}))

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
